/* Variant-aware PDP panels (Borough 22).
 *
 * product-info.js already fetches the product section rendered for a newly
 * selected variant (?variant=<id>&section_id=<id>) and publishes
 * PUB_SUB_EVENTS.variantChange with that parsed document as `html`. Every
 * element marked data-b22-variant-panel is swapped from it by id, so the
 * Description, Allergens & Ingredients and Nutrition tabs and the Thursday-only
 * notice are server rendered per variant: no duplicate markup in the page and
 * no second request. Depends on constants.js + pubsub.js (theme.liquid).
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var html = event && event.data && event.data.html;
    if (!html || typeof html.getElementById !== 'function') return;

    document.querySelectorAll('[data-b22-variant-panel]').forEach(function (panel) {
      var fresh = html.getElementById(panel.id);
      if (!fresh) return;
      panel.innerHTML = fresh.innerHTML;
      panel.hidden = fresh.hidden;
    });
  });

  // Sizes sold one-off only (Box of 4): the Recharge block carries those variant ids
  // (main-product.liquid, section setting b22_size_one_time_only). It is a client-side
  // widget, so it is hidden and set back to one-off here rather than swapped.
  function isOneTimeOnly(variantId) {
    var needle = ',' + variantId + ',';
    return Array.prototype.some.call(document.querySelectorAll('[data-b22-one-time-variants]'), function (block) {
      return block.getAttribute('data-b22-one-time-variants').indexOf(needle) !== -1;
    });
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var variant = event && event.data && event.data.variant;
    if (!variant) return;
    var needle = ',' + variant.id + ',';
    document.querySelectorAll('[data-b22-one-time-variants]').forEach(function (block) {
      var oneTime = block.getAttribute('data-b22-one-time-variants').indexOf(needle) !== -1;
      if (oneTime) {
        var oneOff = block.querySelector('input[name="purchaseOption"][value="onetime"]');
        if (oneOff && !oneOff.checked) oneOff.click();
      }
      block.hidden = oneTime;
    });
  });

  // Runs before product-form.js reads the form: a one-off-only size never goes with a
  // plan, even if the widget is mid re-render.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var id = form && form.elements && form.elements.id;
    if (!id || !isOneTimeOnly(id.value)) return;
    Array.prototype.forEach.call(form.elements, function (field) {
      if (field.name === 'selling_plan') field.value = '';
    });
  }, true);
})();
